const subscriptions = {
    development: {
        custom_enterprise: 20
    },
    production: {
        custom_enterprise: 20   // TODO: CS update value
    }
}

export const SUBSCRIPTIONS_IDS = subscriptions[process.env.NODE_ENV];